var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultipleUsersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 28,
    height: 28,
    rx: 14,
    fill: "#262626"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1585 20.0984C18.1585 18.8613 16.5198 17.8584 14.4984 17.8584C12.477 17.8584 10.8383 18.8613 10.8383 20.0984M21.0866 17.8587C21.0866 16.9402 20.1832 16.1507 18.8905 15.8051M7.91016 17.8587C7.91016 16.9402 8.81355 16.1507 10.1062 15.8051M18.8905 12.8081C19.3398 12.3979 19.6226 11.8019 19.6226 11.1384C19.6226 9.90132 18.6394 8.89844 17.4265 8.89844C16.864 8.89844 16.351 9.11411 15.9624 9.46881M10.1062 12.8081C9.65695 12.3979 9.37421 11.8019 9.37421 11.1384C9.37421 9.90132 10.3574 8.89844 11.5703 8.89844C12.1327 8.89844 12.6458 9.11411 13.0343 9.46881M14.4984 15.6184C13.2855 15.6184 12.3023 14.6156 12.3023 13.3784C12.3023 12.1413 13.2855 11.1384 14.4984 11.1384C15.7113 11.1384 16.6945 12.1413 16.6945 13.3784C16.6945 14.6156 15.7113 15.6184 14.4984 15.6184Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleUsersIcon);
export default __webpack_public_path__ + "static/media/MultipleUsersIcon.22de756d520baa6a539dfd8379638cf3.svg";
export { ForwardRef as ReactComponent };